import { render } from "./kinside-partner-badge.vue?vue&type=template&id=ba8a15ca"
import script from "./kinside-partner-badge.vue?vue&type=script&lang=js"
export * from "./kinside-partner-badge.vue?vue&type=script&lang=js"

import "./kinside-partner-badge.vue?vue&type=style&index=0&id=ba8a15ca&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__